// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"0":"a7d4aa285e43cb58","314":"b6f184cc64094a72","727":"21de2201efc442cb","916":"d8cd1eea1376f097"}[chunkId] + ".js";
};